/**
 * Positions the search drawer below the header chrome (icons row on homepage).
 */
(function () {
  var drawerId = 'SearchDrawer';

  function isHomepage() {
    return document.body.classList.contains('template-index');
  }

  function headerAnchor() {
    if (isHomepage()) {
      return document.querySelector('[data-header-section] .site-header');
    }
    return document.querySelector('[data-header-section]');
  }

  function headerBottom() {
    var bottom = 0;
    var topBar = document.getElementById('shopify-section-top_header');
    var anchor = headerAnchor();

    if (topBar) {
      bottom = Math.max(bottom, topBar.getBoundingClientRect().bottom);
    }
    if (anchor) {
      bottom = Math.max(bottom, anchor.getBoundingClientRect().bottom);
    }

    return Math.max(0, Math.round(bottom));
  }

  function syncSearchDrawer() {
    var drawer = document.getElementById(drawerId);
    if (!drawer) return;

    var top = headerBottom();
    drawer.style.setProperty('--mp-search-top', top + 'px');
    drawer.style.height = 'auto';

    var searchBtn = document.querySelector('.site-header__search-toggle');
    if (isHomepage() && searchBtn && window.matchMedia('(min-width: 750px)').matches) {
      var btnRect = searchBtn.getBoundingClientRect();
      drawer.style.setProperty('--mp-search-right', Math.max(16, window.innerWidth - btnRect.right) + 'px');
      drawer.classList.add('mp-search-drawer--homepage');
    } else {
      drawer.style.removeProperty('--mp-search-right');
      drawer.classList.toggle('mp-search-drawer--homepage', isHomepage());
    }
  }

  function watchDrawerOpen() {
    var observer = new MutationObserver(function () {
      if (document.documentElement.classList.contains('js-drawer-open-top')) {
        syncSearchDrawer();
        requestAnimationFrame(syncSearchDrawer);
      }
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  function init() {
    syncSearchDrawer();
    watchDrawerOpen();
    window.addEventListener('resize', syncSearchDrawer, { passive: true });
    document.addEventListener('shopify:section:load', syncSearchDrawer);

    document.querySelectorAll('[data-predictive-search-open-drawer]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        requestAnimationFrame(syncSearchDrawer);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
